import { ENV_VARS, Environments } from './env';

export enum ExternalService {
  Amplitude = 'amplitude',
  Sentry = 'sentry',
  Clarity = 'clarity',
  Intercom = 'intercom',
}

const ENABLED_ENVIRONMENTS: Record<ExternalService, readonly Environments[]> = {
  [ExternalService.Amplitude]: [
    Environments.STAGING,
    Environments.SANDBOX,
    Environments.PRODUCTION,
  ],
  [ExternalService.Sentry]: [
    Environments.STAGING,
    Environments.SANDBOX,
    Environments.PRODUCTION,
  ],
  [ExternalService.Clarity]: [Environments.PRODUCTION],
  [ExternalService.Intercom]: [
    Environments.STAGING,
    Environments.SANDBOX,
    Environments.PRODUCTION,
  ],
};

export const isServiceEnabled = (
  service: ExternalService,
  environment: Environments = ENV_VARS.environment,
): boolean => ENABLED_ENVIRONMENTS[service].includes(environment);
